import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import {Box, Chip, Drawer, Stack, Typography, useMediaQuery} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from 'store/constant';
import logo from "../../assets/images/StearnsBank-logo-2022-225px.webp";

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const drawerContent = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>
            <MenuList />
        </>
    );

    const footer = (
        <Stack direction="column" justifyContent="center" sx={{ ml:5, mr:2, mt:-5, }}>
            <img src={logo} alt="Mozrt" width="75" />
            <Typography variant={"subtitle2"} sx={{mt:1}}>Banking services provided by Stearns Bank N.A., Member FDIC.</Typography>
        </Stack>
    );

    const drawer = (
        <>
            <MobileView>
                <Box sx={{ px: 2, height: 'calc(100% - 48px)', overflow: 'auto' }}>
                    {drawerContent}
                </Box>
                {footer}
            </MobileView>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: `calc(100vh - ${matchUpMd ? '88px' : '56px'} - 48px)`,
                        paddingLeft: '16px',
                        paddingRight: '16px'
                    }}
                >
                    {drawerContent}
                </PerfectScrollbar>
                {footer}
            </BrowserView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};


Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
